export default __webpack_public_path__ + "static/media/AccountConfirmation.4adf76d0.svg";